import React from "react";
import Input from "./Input";
import Field from "./Field";

const InputField = React.forwardRef(
  (
    {
      className,
      inputClassName,
      icon,
      error,
      lessSpace,
      inverseError,
      onChangeValue,
      pathName,
      gstValidation,
      ...rest
    },
    ref
  ) => (
    <Field
      icon={icon}
      error={error}
      inverseError={inverseError}
      className={className}
      lessSpace={lessSpace}
      gstValidation={gstValidation}
      pathName={pathName}
    >
      <Input withIcon={!!icon} ref={ref} className={inputClassName} onChangeValue={onChangeValue} pathName={pathName} {...rest} />
    </Field>
  )
);

export default InputField;
